import computed from './computed'
import components from './components'
import resources from './resources'
import data from './data'
import methods from './methods'
// import validations from './validations'

export default {
  computed,
  components,
  data,
  methods,
  // validations,

  mixins: [resources]
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/history/index/resources/index.js